import React, { useState } from "react";
import "./DisburseReview.scss";
// import PersonalColumn from "./PersonalColumn";
// import AddressColumn from "./AddressColumn";
// import IncomeColumn from "./IncomeColumn";
// import EducationColumn from "./EducationColumn";
// import Declaration from "../Declaration";
// import BtnSet from "../IdfcLetterHead/BtnSet";
import FooterText from "../modules/FooterText";
import { useSelector } from "react-redux";
import { GetBaseUrl } from "../modules/getBaseUrl";
import BankColumn from "./BankDetails";
import SpocColumn from "./SpocDetails";

function DisburseReview() {
  const eduInfo = useSelector((state) => state.education.eduInfo);

  const [boxes, setBoxes] = useState({});
  const tokenData = useSelector((state) => state.tokens.tokens);
  let url = window.location.href;
  let baseUrl = GetBaseUrl(url);
  // if (tokenData.applicationStatus !== "Registered") {
  //   window.location.replace(baseUrl + "/application/app-preview");
  // }
  const setBoxData = (e) => {
    setBoxes(e);
  };
  return (
    <div className="form-div dis-review">
     {eduInfo?.campusSpecific === "Others" && <div className="review-heading">
        <div className="form-title">My Scholarship Disbursement Form</div>
      </div>}
      {/* {eduInfo?.campusSpecific === "Others" &&
      <BankColumn />} */}
      <SpocColumn others={eduInfo?.campusSpecific === "Others"}/>
      
      {/* {tokenData.applicationStatus === "Registered" && <BtnSet boxes={boxes} />} */}
      <FooterText />
    </div>
  );
}

export default DisburseReview;
